import { useEffect, useState } from "react";
import { Switch } from "../../components/ui/switch";
import { api } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import { useLoad, act, Card, H1, abtn, ainput } from "../../components/admin/ui";

const KILLS = [["global", "Arrêt d'urgence global"], ["ads", "Publicités"], ["orders", "Commandes / ventes"], ["publications", "Publications"], ["refunds", "Remboursements"]];
const LEVELS = [[1, "Niveau 1 — automatisation courante uniquement (sync, prix, brouillons, rapports)"], [2, "Niveau 2 — automatisation financière contrôlée (publications, campagnes limitées, commandes, remboursements sous plafonds)"], [3, "Niveau 3 — identique au N2 ; les actions N3 restent soumises à validation du propriétaire"]];

export default function Controls() {
  const { user } = useApp();
  const [s, reload] = useLoad("/admin/settings");
  const [th, setTh] = useState({});
  const [lvl, setLvl] = useState({ level: 2, scheduler_enabled: true });
  useEffect(() => { if (s) { setTh(s.thresholds); setLvl({ level: s.autonomy_level, scheduler_enabled: s.scheduler_enabled }); } }, [s]);
  if (!s) return <div className="label-xs">Chargement…</div>;
  const kill = async (d, v) => { await act(() => api.put("/admin/settings/kill", { domain: d, value: v }), `Interrupteur ${d} : ${v ? "ACTIVÉ" : "désactivé"}`); reload(); };
  const changed = Object.fromEntries(Object.entries(th).filter(([k, v]) => Number(v) !== s.thresholds[k]).map(([k, v]) => [k, Number(v)]));
  const l3 = Object.keys(changed).filter((k) => s.level3_keys.includes(k));
  const saveTh = async () => {
    const confirm = l3.length ? window.confirm(`Modification de niveau 3 (${l3.join(", ")}). Confirmer explicitement ?`) : false;
    if (l3.length && !confirm) return;
    await act(() => api.put("/admin/settings/thresholds", { values: changed, confirm }), "Seuils enregistrés et audités");
    reload();
  };
  const saveLvl = async () => { if (!window.confirm("Changer la politique d'autonomie (niveau 3) ?")) return; await act(() => api.put("/admin/settings/autonomy", { ...lvl, confirm: true }), "Politique d'autonomie mise à jour"); reload(); };
  return (
    <div>
      <H1 sub="Interrupteurs indépendants, politique d'autonomie à 3 niveaux et seuils financiers. Toute modification est auditée ; les changements de niveau 3 exigent le propriétaire et une confirmation explicite.">Contrôles & autonomie</H1>
      <div className="grid lg:grid-cols-2 gap-4 mb-4">
        <Card title="Interrupteurs d'urgence" testid="kill-switches">
          {KILLS.map(([d, l]) => (
            <div key={d} className="flex justify-between items-center py-3 border-b border-[#1E222D]">
              <span className={`text-sm ${s.kill[d] ? "text-red-400" : ""}`}>{l} {s.kill[d] && "— BLOQUÉ"}</span>
              <Switch data-testid={`kill-switch-${d}`} checked={s.kill[d]} onCheckedChange={(v) => kill(d, v)} />
            </div>
          ))}
          <div className="text-xs text-slate-500 mt-3">Interrupteurs par fournisseur : page Fournisseurs.</div>
        </Card>
        <Card title="Politique d'autonomie (propriétaire)" testid="autonomy-policy">
          {LEVELS.map(([v, l]) => (
            <label key={v} className="flex gap-3 items-start py-2 text-sm cursor-pointer">
              <input type="radio" data-testid={`autonomy-level-${v}`} checked={lvl.level === v} onChange={() => setLvl({ ...lvl, level: v })} disabled={user.role !== "owner"} />{l}
            </label>
          ))}
          <label className="flex justify-between items-center py-3 text-sm border-t border-[#1E222D] mt-2">Planificateur 24/7 des agents<Switch data-testid="scheduler-toggle" checked={lvl.scheduler_enabled} onCheckedChange={(v) => setLvl({ ...lvl, scheduler_enabled: v })} disabled={user.role !== "owner"} /></label>
          <button data-testid="autonomy-save" disabled={user.role !== "owner"} onClick={saveLvl} className={abtn}>Enregistrer la politique</button>
        </Card>
      </div>
      <Card title="Seuils financiers et règles" right={<button data-testid="thresholds-save" disabled={!Object.keys(changed).length} onClick={saveTh} className={abtn}>Enregistrer ({Object.keys(changed).length})</button>}>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="thresholds-form">
          {Object.keys(s.thresholds).map((k) => (
            <label key={k} className="block">
              <span className="label-xs">{k}{s.level3_keys.includes(k) && <span className="text-amber-400"> · N3</span>}</span>
              <input data-testid={`threshold-${k}`} type="number" step="any" value={th[k] ?? ""} onChange={(e) => setTh({ ...th, [k]: e.target.value })} className={`${ainput} w-full mt-1 ${changed[k] !== undefined ? "border-amber-500/60" : ""}`} />
            </label>
          ))}
        </div>
      </Card>
    </div>
  );
}
